;
(function($) {

	$.fn.aniMobileLiveMenu = function() {

		if (this.length > 1) {
			console.log("Ani live menu is applicable only to single element.");
		}

		this.find(".expander").addClass("initialised-expander");

		this.addClass("initialised-livemenu");

		this.on("click", ".expander", function() {
			var $this = $(this);
			var $div = $this.closest("[data-master]");
			var myLevel = $div.attr("data-level");
			var $menu = $this.closest(".initialised-livemenu");
			var $subs = [];
			var stopped = false;
			$div.nextAll().each(function() {
				var $nextThis = $(this);
				if (!stopped && $nextThis.attr("data-level") > myLevel) {
					$subs.push(this);
				} else {
					stopped = true;
				}
			});
			$subs = $($subs);
			var currentId = $this.attr("data-id");

			if ($div.is(".expanded")) {
				$div.removeClass("expanded");
				$subs.slideUp(300);

			} else {
				// open
				$div.addClass("expanded");
				if ($subs.length > 0) { // Pouze zobrazit již načtené
					$subs.slideDown(300);
				} else { // Načíst ajaxem
					var feedUrl = $menu.attr("data-feed-url");
					$.get(feedUrl, {"id": currentId}, function(responseJson) {
						var $pointAfter = $div.next();
						var totalLength = responseJson.length;
						var basePattern = $menu.attr("data-pattern");
						var added = [];
						$.each(responseJson, function(i, r) {
							var html = basePattern;

							html = html.replace(/%nadpis%/g, r.nadpis);
							html = html.replace(/%id%/g, r.id);
							html = html.replace(/%uroven%/g, r.uroven);
							html = html.replace(/%odkaz%/g, r.odkaz);
							html = html.replace(/%master%/g, r.master);
							html = html.replace(/%with-children%/g, (r.potomci && r.potomci.length) ? "with-children" : "");
							
							if (r.potomci && r.potomci.length) {
								var expanderHtml = "<a href='#' class='expander' data-id='"+r.id+"'></a>";
								html = html.replace(/%expander%/g, expanderHtml);
							} else {
								html = html.replace(/%expander%/g, "");
							}
							
							$div.after(html);
						});
						$div.nextUntil($pointAfter).hide().slideDown(200);
					}, "json");
				}
			}
			return false;
		});		

		return this;

	};

})(jQuery);